export default "__VITE_ASSET__CIaXG_Vi__"